const ANIMATION_SPEED = 1000;
let ACTIVE = false;

export class IFrameAPI {
    static initialize() {
        if (IFrameAPI.isEmbedded()) {
            window.addEventListener('message', (e) => {
                IFrameAPI.handleEvent(e);
            });
            window.parent?.postMessage({ type: 'initialized' }, "*");
            ACTIVE = true;
            console.log("Initialized IFrame API");
        }
        else {
            console.log("Not initializing IFrame API");
        }
    }

    /**
     * @returns true if the current window is embedded as an iframe in another website
     */
    static isEmbedded() {
        return window.self !== window.top && window.self.location.toString().includes("api"); 
    }

    static handleEvent(e) {
        if (!ACTIVE) { return; }
        if (e.data.type === "followPlayer") {
            const followEvent = {
                playerId: e.data.playerId,
                animate: e.data.animate
            };
            console.debug("Received follow event from parent:", followEvent);

            if (!followEvent.animate) {
                window.bluemap.mapViewer.controlsManager.controls.stopFollowingPlayerMarker();
                IFrameAPI.followPlayer(followEvent.playerId);
            }
            else {
                const startPosition = bluemap.mapViewer.controlsManager.data.position;
                const endPosition = this.getPlayerPositionOrNull(followEvent.playerId);
                if (!endPosition) { return; }
                window.bluemap.mapViewer.controlsManager.controls.stopFollowingPlayerMarker();
                IFrameAPI.animateToPosition(startPosition.x, startPosition.y, startPosition.z, endPosition.x, endPosition.y, endPosition.z, () => IFrameAPI.followPlayer(followEvent.playerId));
            }
        }
        else if (e.data.type === "unfollowPlayer") {
            window.bluemap.mapViewer.controlsManager.controls.stopFollowingPlayerMarker();
        }
        else if (e.data.type === "updatePosition") {
            const updatePositionEvent = {
                x: e.data.x,
                y: e.data.y,
                x: e.data.z,
            };
            console.debug("Received update position event from parent:", updatePositionEvent);
            IFrameAPI.updatePosition(updatePositionEvent.x, updatePositionEvent.y, updatePositionEvent.z);
        }
    }

    static followPlayer(playerId) {
        if (!ACTIVE) { return; }
        console.debug("Actively following:", playerId);
        const playerMarker = window.bluemap.playerMarkerManager.getPlayerMarker(playerId);
        if (playerMarker) {
            window.bluemap.mapViewer.controlsManager.controls.followPlayerMarker(playerMarker);
        }
    }

    static updatePosition(x, y, z) {
        if (!ACTIVE) { return; }
        if (window.bluemap?.mapViewer?.controlsManager?.data?.position) {
            window.bluemap.mapViewer.controlsManager.data.position.setX(parseFloat(x));
            window.bluemap.mapViewer.controlsManager.data.position.setY(parseFloat(y));
            window.bluemap.mapViewer.controlsManager.data.position.setZ(parseFloat(z));
            window.bluemap.mapViewer.controlsManager.distance = parseFloat(y);
            window.bluemap.mapViewer.redraw();
        }
    }

    static animateToPosition(startX, startY, startZ, endX, endY, endZ, endCallback) {
        if (!ACTIVE) { return; }
        const startTime = performance.now();

        function animate(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / ANIMATION_SPEED, 1);

            // Easing function (ease-out-cubic)
            const eased = 1 - Math.pow(1 - progress, 3);

            const newX = startX + (endX - startX) * eased;
            const newY = startY + (endY - startY) * eased;
            const newZ = startZ + (endZ - startZ) * eased;

            IFrameAPI.updatePosition(newX, newY, newZ);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
            else {
                endCallback();
            }
        }

        requestAnimationFrame(animate);
    }

    static getPlayerPositionOrNull(playerId) {
        if (!ACTIVE) { return; }
        const playerMarker = window.bluemap.playerMarkerManager.getPlayerMarker(playerId);
        if (playerMarker) {
            return playerMarker.position;
        }
        return null;
    }

    static onPlayerJoined(markerData) {
        if (!ACTIVE) { return; }
        const player = {
            id: markerData.uuid,
            name: markerData.name,
            position: {
                x: markerData.position.x,
                y: markerData.position.y,
                z: markerData.position.z
            },
            visible: !markerData.foreign
        };
        console.debug("new player:", player);
        window.parent?.postMessage({ type: 'playerJoined', player: player }, "*");
    }

    static onPlayerVisibilityChanged(markerData) {
        if (!ACTIVE) { return; }
        const player = {
            id: markerData.uuid,
            name: markerData.name,
            position: {
                x: markerData.position.x,
                y: markerData.position.y,
                z: markerData.position.z
            },
            visible: !markerData.foreign
        };
        console.debug("visibility changed for:", player);
        window.parent?.postMessage({ type: 'playerVisibilityChanged', player: player }, "*");
    }

    static onPlayerQuit(marker) {
        if (!ACTIVE) { return; }
        const player = {
            id: marker.data.playerUuid,
            name: marker.data.name,
            position: {
                x: marker.data.position.x,
                y: marker.data.position.y,
                z: marker.data.position.z,
            },
            visible: marker.data.visible
        };
        window.parent?.postMessage({ type: 'playerQuit', player: player }, "*");
    }
}